import React, { useState, useEffect } from 'react';
import { ListProducts } from '../../actions/productAction';
import { useSelector, useDispatch } from 'react-redux';
import Axios from '../../axios/axios';
import { ToastContainer, toast } from 'react-toastify';

export default function Availability() {
  const dispatch = useDispatch();

  const [product, setProduct] = useState('');
  const [startDate, setStartDate] = useState('');
  const today = new Date().toISOString().split('T')[0]
  const [endDate, setEndDate] = useState('');
  const [qnty, setQnty] = useState(1);

  const [availability, setAvailability] = useState('');
  const [days, setDays] = useState(1);
  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  useEffect(() => {
  if (availability === 200) {
    toast.success(`Item available for this date`, {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  } else if (availability === 400) {
    toast.success(`Item is available for this date`, {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  } else if (availability === 402) {
    toast.success(`Stock not available for this date`, {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  }
}, [availability]);


  useEffect(() => {
    dispatch(ListProducts({ pagination: false }));
  }, [dispatch]);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const onSubmit = async (e) => {
    e.preventDefault();

    const data = {
      product,
      startDate,
      endDate,
      qnty
    };
    await Axios.post(`/api/order/check`, data).then((res) => {
      if (res.data.balStock < qnty) {
        console.log(res.data.code)
        toast.error(`🦄 ${res.data.balStock} Stocks Available`, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
        return;
      }
      setAvailability(res.data.code);

      //  else {
      //   setAvailability(res.data.code);
      // }
    });
  };

  const handleStartDate = (val) => {
    setStartDate(val);

    handleNUmberOfDays(1, val);
  };

  const handleNUmberOfDays = (val, date_) => {
    setDays(val);

    const startDate_ = new Date(date_);
    startDate_.setDate(startDate_.getDate() + parseInt(val) - 1);
    console.log(startDate);
    const year = startDate_.getFullYear();
    const month = startDate_.getMonth() + 1; // Months are 0-indexed, so add 1
    const day = startDate_.getDate();

    let date = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''
      }${day}`;

    setEndDate(date);
  };

  return (
    <div>
      {' '}
      <form onSubmit={onSubmit}>
        <div class="row">
          <div class="col-md-4 mb-4 stretch-card transparent">
            <div class="card card-tale">
              <div class="card-body">
                <p class="mb-4">Select Product</p>
                <select
                  className="form-control"
                  required
                  value={product}
                  onChange={(e) => setProduct(e.target.value)}
                >
                  <option value="">Select Product</option>
                  {products?.map((data) => (
                    <option value={data._id}>{data.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>


          {/* <div class="col-md-4 mb-4 stretch-card transparent">
            <div class="card card-tale">
              <div class="card-body">
                <p class="mb-4">Start Date</p>
                <input
                  type="date"
                  className="form-control"
                  required
                  value={startDate}
                  min={today}
                  onChange={(e) => setStartDate(e.target.value)}
                />

              </div>
            </div>

            
          </div> */}
          {/* <div className="col-3">
            {' '}
            <p class="mb-4">Days</p>
            <input
              type="number"
              className="form-control"
              required
              value={days}
              min={1}
              onChange={(e) => handleNUmberOfDays(e.target.value, startDate)}
              disabled={startDate === '' ? true : false}
              
            />
          </div> */}
          {/* <div className="col">
            {' '}
            <p class="mb-4">End Date</p>
            {/* <input
                            type="text"
                            className="form-control"
                            required
                            value={endDate}
                            // onChange={(e) => setStartDate(e.target.value)}
                          /> */}
          {/* <span style={{ fontSize: '10px', fontWeight: '500' }}>
              {' '}
              {endDate}
            </span>
          </div> */}
          {/* <div class="card card-tale">
            <div class="card-body">
              <p class="mb-4">End Date</p>
              <input
                type="date"
                className="form-control"
                required
                value={endDate}
                min={today}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div> */}

          <div class="col-md-6 mb-4 stretch-card transparent">
            <div class="card card-tale">
              <div class="card-body">
                <p class="mb-4">Start Date</p>
                <input
                  type="date"
                  className="form-control"
                  required
                  value={startDate}
                  min={today}
                  onChange={(e) => handleStartDate(e.target.value)}
                />
                <div className="row">
                  <div className="col-6">
                    {' '}
                    <p class="mb-1">Days</p>
                    <input
                      type="number"
                      className="form-control"
                      required
                      value={days}
                      min={1}
                      onChange={(e) =>
                        handleNUmberOfDays(e.target.value, startDate)
                      }
                      disabled={startDate === '' ? true : false}
                    />
                  </div>
                  <div className="col">
                    {' '}
                    <p class="mb-1">End Date</p>
                    {/* <input
                      type="text"
                      className="form-control"
                      required
                      value={endDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    /> */}
                    <span style={{ fontSize: '20px', fontWeight: '500' }}>
                      {' '}
                      {endDate}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    {' '}
                    <p class="mb-1">Qnt</p>
                    <input
                      type="number"
                      className="form-control"
                      required
                      value={qnty}
                      min={1}
                      onChange={(e) => setQnty(e.target.value)}
                      disabled={startDate === '' ? true : false}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
   <button
  type="submit"
  className="btn btn-secondary btn-sm"
  style={{ padding: '5px 10px', fontSize: '14px' }}
>
  Search Availability
  <i className="ti-search float-right"></i>
</button>


          {/* {availability === 200 && (
            <div
              class="alert alert-success alert-dismissible fade show mt-2"
              role="alert"
            >
              <strong>Not Available!</strong> Items not available for this date



              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          )}
          {availability === 400 && (
            <div
              class="alert alert-Danger alert-dismissible fade show mt-2"
              role="alert"
            >
              <strong>Items available for this date!</strong>


              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          )} */}
          {/* {availability === 200 && (
            toast.success(`Item available for this date`, {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
            })

          )} */}
          {/* {availability === 400 && (

            toast.success(`Item is available for this date`, {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
            })
          )} */}
          {/* {availability === 402 && (
            toast.success(`Stock not available for this date`, {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
            })
          )} */}
        </div>
      </form>
      <ToastContainer />

    </div>
  );
}
